import { Status } from '@dreryk/egabinet-waitlist-frontend-api';

import {
   FilterPanelControllerCodecConfigBoolean,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { WaitlistFilterPanelSearchParam } from '../../WaitlistFilterPanel.types';

export const STATUSES: Status[] = ['PENDING', 'REGISTERED', 'CONFIRMED', 'COMPLETED', 'SUSPENDED', 'REMOVED'];

const URGENT_PARAM_VALUE = 'tak';

export const urgentCodec: FilterPanelControllerCodecConfigBoolean = {
   type: 'boolean',
   paramValue: URGENT_PARAM_VALUE,
};

export const urgentDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   boolean,
   WaitlistFilterPanelSearchParam.URGENT
> = () => {
   return [
      {
         targetValue: null,
         label: translationKeys.urgent.plural,
         testId: 'urgent',
      },
   ];
};

export const urgentDeserializer = (currentParamValue: string | null): boolean =>
   currentParamValue === URGENT_PARAM_VALUE;
